import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"

vue.use(vuex);

const nivelpnd = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api`,
    state: {
        nivelespnd: [],
        nivelespndbypunto: [],
        nivelespndbynivel: [],
        niveleshijospnd: [],
        nivelesrecursospnd: [],
    }
}).get({
    action: "get_nivelespnd",
    path: function (obj) {
        return `/nivelpnd/plan/${obj.idplannacionaldesarrollo}/${obj.nivelconfigurado}`;
    },
    onSuccess: (state, payload) => {
        state.nivelespnd = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.nivelespnd = [];
    }
}).get({
    action: "get_nivelespndbypunto",
    path: function (obj) {
        return `/nivelpnd/planbypuntoPeriodo/${obj.idpunto}/${obj.periodo}`;
    },
    onSuccess: (state, payload) => {
        state.nivelespndbypunto = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.nivelespndbypunto = [];
    }
}).get({
    action: "get_nivelpndbynivel",
    path: function (obj) {
        return `/nivelpnd/planbypunto/${obj.idpunto}/${obj.idnivelpnd}`;
    },
    onSuccess: (state, payload) => {
        state.nivelespndbynivel = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.nivelespndbypunto = [];
    }
}).get({
    action: "get_niveleshijospnd",
    path: function (obj) {
        return `/nivelpnd/plan/${obj.idplannacionaldesarrollo}/${obj.nivelconfigurado}`;
    },
    onSuccess: (state, payload) => {
        state.niveleshijospnd = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.niveleshijospnd = [];
    }
}).get({
    action: "get_nivelrecursopnd",
    path: function (obj) {
        return `/nivelrecursopnd/plan/${obj.idplannacionaldesarrollo}`;
    },
    onSuccess: (state, payload) => {
        state.nivelesrecursospnd = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.nivelesrecursospnd = [];
    }
}).getStore();

nivelpnd.getters = {
    gnivelpnd: state => {
        return state.nivelespnd
    },
    gnivelpndbypunto: state => {
        return state.nivelespndbypunto
    },
    gnivelpndbynivel: state => {
        return state.nivelespndbynivel
    },
    gnivelhijopnd: state => {
        return state.niveleshijospnd
    },
    gnivelrecursopnd: state => {
        return state.nivelesrecursospnd
    }
}

export default nivelpnd;